import { render, staticRenderFns } from "./SocialMediaActions.vue?vue&type=template&id=0fdbc5c6&"
import script from "./SocialMediaActions.vue?vue&type=script&lang=js&"
export * from "./SocialMediaActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports